'use strict';

frontendApp.directive('iioThemeImage', ['$rootScope', 'ThemeService', function ($rootScope, ThemeService) {

  return {
    restrict: 'A',
    scope: false,
    link: function (scope, element, attrs) {

      scope.theme = ThemeService.getCurrentTheme();
      scope.$on(ThemeService.EVENTS.THEME_CHANGED, function (evt, theme) {
        scope.theme = theme;
      });

    }
  }

}]);
